<template>
  <div class="goodsfreightReduction">
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="from1"
      @Refresh="Refresh"
      @search="search"
    >
      <template v-slot:left>
        <el-button type="warning" @click="allclick">新增</el-button>
        <!-- <el-button
          @click="onHandleExport"
          type="warning"
          icon="el-icon-upload2"
          :disabled="disabledExport"
          >导出</el-button
        > -->
      </template>
    </Filtersearch>

    <div class="auto-table-flex">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="index" width="80" align="center" label="序号">
        </el-table-column>
        <el-table-column
          prop="supplier_title"
          align="center"
          label="供应商名称"
        >
          <template slot-scope="scope">
            <div>
              <div>{{ scope.row.supplier_title }}</div>
              <div>{{ scope.row.supplier_mobile }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="logistic_name" align="center" label="集配中心">
        </el-table-column>
        <el-table-column prop="buyer_fullname" align="center" label="对接业务">
          <template slot-scope="scope">
            <div>
              <div>{{ scope.row.buyer_fullname }}</div>
              <div>{{ scope.row.buyer_mobile }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="product_title" align="center" label="商品名称">
          <template slot-scope="scope">
            <el-button type="text">{{ scope.row.product_title }}</el-button>
          </template>
        </el-table-column>

        <el-table-column prop="sku_code" align="center" label="货号">
          <template slot-scope="scope">
            <el-button type="text" @click="onHandelDetails(scope.row)">{{
              scope.row.sku_code
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="start_time_text" align="center" label="生效时间">
          <template slot-scope="scope">
            {{ scope.row.start_time_text }}-{{ scope.row.end_time_text }}
          </template>
        </el-table-column>

        <el-table-column
          prop="discount_text"
          align="center"
          label="折扣
"
        >
        </el-table-column>
        <el-table-column
          prop="status_type"
          align="center"
          label="状态
"
        >
        </el-table-column>
        <el-table-column prop="operator_name" align="center" label="创建人">
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="50"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <GoodsDetails ref="GoodsDetailsref"></GoodsDetails>

    <el-dialog
      :title="!ruleForm.id ? '添加商品折扣' : '编辑商品折扣'"
      :visible.sync="centerDialogVisible"
      v-if="centerDialogVisible"
      width="500px"
      class="dialog"
      center
    >
      <div class="contents">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="添加商品" prop="sku_code">
            <div style="width: 302px">
              <el-autocomplete
                style="width: 100%"
                v-model="ruleForm.product_title"
                :fetch-suggestions="
                  (queryString, cb) => querySearchAsync('1', queryString, cb)
                "
                placeholder="输入商品名称/货号"
                @select="handleSelect"
              ></el-autocomplete>
            </div>
          </el-form-item>
          <el-form-item label="折扣" prop="discount_percent">
            <div style="width: 302px">
              <el-select
                v-model="ruleForm.discount_percent"
                clearable
                placeholder="上架状态"
              >
                <el-option label="免运费" :value="0"></el-option>
                <el-option label="1折" :value="10"></el-option>
                <el-option label="2折" :value="20"></el-option>
                <el-option label="3折" :value="30"></el-option>
                <el-option label="4折" :value="40"></el-option>
                <el-option label="5折" :value="50"></el-option>
                <el-option label="6折" :value="60"></el-option>
                <el-option label="7折" :value="70"></el-option>
                <el-option label="8折" :value="80"></el-option>
                <el-option label="9折" :value="90"></el-option>
                <el-option label="无折扣" :value="100"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="有效期" prop="end_time">
            <div>
              <el-date-picker
                v-model="value1"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="startchanghe"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
              >
              </el-date-picker>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="ruleFormqr">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import GoodsDetails from "@/components/GlobalDetails.vue";
import Filtersearch from "@/components/Filtersearch.vue";
import { postBuyerSelectList } from "@/api/general/operation-center/index";

export default {
  name: "supplier",
  components: {
    Filtersearch,
    GoodsDetails,
  },
  data() {
    return {
      value1: [],
      loadingselect: false,
      currentPage: 0,
      total: 0,
      loading: false,
      disabledExport: false, // 导出按钮
      tableData: [],
      centerDialogVisible: false,
      Filterdata: "",
      itemobj: "",
      ruleForm: {
        id: "", // 可选，记录ID（有值则为更新，无值则为新增）
        sku_code: "", // 必填，商品货号
        discount_percent: "", // 必填，折扣比例（0=免运费，10=1折，20=2折...90=9折，100=无折扣）
        start_time: "", // 必填，开始时间（时间戳）
        end_time: "", // 必填，结束时间（时间戳）
        product_title: "",
        // operator_id: "", // 新增时必填，操作人ID
        // operator_name: "", // 新增时必填，操作人姓名
      },
      from: {
        page: 1, //	T文本	是
        pageSize: 50, //	T文本	是
        logistic_business_id: "", // 可选，集配中心ID（2=高碑店，549=孝感）
        sku_code: "", // 可选，货号（模糊搜索）
        product_title: "", // 可选，商品名称（模糊搜索）
        supplier_id: "", // 可选，供应商名称（模糊搜索）
        buyer_id: "", // 可选，业务关键词（采购员姓名或手机号）
        status: "", // 可选，状态（active=生效中，expired=已过期，not_start=未开始）
      },
      from1: "",
      Selectionlist: [],

      rules: {
        sku_code: [{ required: true, message: "请选择商品", trigger: "blur" }],
        discount_percent: [
          { required: true, message: "请选择折扣", trigger: "change" },
        ],

        end_time: [
          { required: true, message: "请选择有效期", trigger: "change" },
        ],
      },

      Filtersearchlist: [
        {
          type: "select",
          name: "集配中心",
          clearable: true,
          filterable: true,
          model: "logistic_business_id",
          placeholder: "请选集配中心",
          label: "name",
          value: "id",
          selectoption: [],
          selectoptionname: "business_list",
        },
        {
          type: "input",
          name: "货号",
          clearable: true,
          model: "sku_code",
          placeholder: "请输入货号",
        },
        {
          type: "input",
          name: "商品名称",
          clearable: true,
          model: "product_title",
          placeholder: "请输入商品名称",
        },

        {
          type: "select",
          name: "供应商",
          clearable: true,
          filterable: true,
          model: "supplier_id",
          placeholder: "请选择供应商",
          label: "title",
          value: "id",
          selectoption: [],
          selectoptionname: "supplier_list",
        },
        {
          type: "select",
          name: "业务",
          clearable: true,
          filterable: true,
          model: "buyer_id",
          placeholder: "请选择业务",
          label: "fullname",
          value: "id",
          selectoption: [],
          selectoptionname: "buyer_list",
        },

        {
          type: "select",
          name: "状态",
          clearable: true,
          model: "status",
          placeholder: "请选状态",
          label: "label",
          value: "value",
          selectoption: [
            {
              label: "生效中",
              value: "1",
            },
            {
              label: "已过期",
              value: "2",
            },
            {
              label: "未开始",
              value: "3",
            },
          ],
        },
      ],
    };
  },
  created() {
    this.from1 = JSON.parse(JSON.stringify(this.from));
    this.hqlist();
    this.getsearch();
    this.postAjaxBuyerSelectList();
  },
  watch: {},
  methods: {
    ruleFormqr() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$api.fr
            .platformfreightdiscountproductsave(this.ruleForm)
            .then((res) => {
              console.log(res, "11111111111111");
              if (this.ruleForm.id) {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
              }
              this.centerDialogVisible=false;
                 this.hqlist();
            });
        }
      });
    },
    startchanghe() {
      if (this.value1 && this.value1.length > 1) {
        this.ruleForm.start_time = this.value1[0];
        this.ruleForm.end_time = this.value1[1];
      } else {
        this.ruleForm.start_time = "";
        this.ruleForm.end_time = "";
      }
    },
    handleSelect(item) {
      console.log(item, "是选择吗");
      this.ruleForm.sku_code = item.id;
    },
    querySearchAsync(type, queryString, cb, i) {
      // console.log( query,111111111111)
      // this.queryname(type, queryString,cb, i);
      if (queryString !== "") {
        this.loadingselect = true;
        this.$api.fr
          .platformfreightdiscountproductinfo({
            keyword: queryString, //	是	pi模糊查询
            type: type,
          })
          .then((res) => {
            console.log(res, "11111111");
            // this.typemethod(type, queryString, res, i);
            let namedata = [];

            namedata = res.data.map((el) => {
              return {
                value: `${el.product_title}[${el.sku_code}][${el.supplier_title}]`,
                id: el.sku_code,
              };
            });
            cb(namedata);
            this.loadingselect = false;
          });
      } else {
        this.ruleForm.product_title = "";
        this.ruleForm.sku_code = "";
      }
    },
    /**
     * 展示详情
     */
    onHandelDetails(row) {
      // this.detailsVisible = true;
      // this.detailsLoading = true;
      this.goodsDetail = {
        ...row,
      };
      // // 模拟loading
      // setTimeout(() => {
      //   this.detailsLoading = false;
      // }, 500);
      this.$refs.GoodsDetailsref.hqlist(this.goodsDetail);
    },
    handleEdit(e) {
      //   this.itemobj = e;
         this.ruleForm={
        id:e.id, // 可选，记录ID（有值则为更新，无值则为新增）
        sku_code:e.sku_code, // 必填，商品货号
        discount_percent: e.discount_percent, // 必填，折扣比例（0=免运费，10=1折，20=2折...90=9折，100=无折扣）
        start_time: e.start_time_text, // 必填，开始时间（时间戳）
        end_time: e.end_time_text, // 必填，结束时间（时间戳）
        product_title:   `${e.product_title}[${e.sku_code}][${e.supplier_title}]`,
        // operator_id: "", // 新增时必填，操作人ID
        // operator_name: "", // 新增时必填，操作人姓名
      },
this.value1=[e.start_time_text,e.end_time_text];
      //   this.ruleForm.audit_status = 1;
      //   this.ruleForm.audit_reason = '';
      this.centerDialogVisible = true;
    },
    allclick() {
        this.value1=[];
        Object.assign(this.$data.ruleForm, this.$options.data().ruleForm);
      this.centerDialogVisible = true;
    },
    /**
     * 获取业务下拉列
     */
    async postAjaxBuyerSelectList() {
      // this.loadingBuyerList = true;
      try {
        const { data } = await postBuyerSelectList();

        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "buyer_list"
          ) {
            console.log(data, "222222");
            el.selectoption = [...data];
          }
        });
      } catch (err) {
        console.log("ajax postBuyerSelectList err", err);
      } finally {
        // this.loadingBuyerList = false;
      }
    },

    getsearch() {
      this.$api.ban.searchdata().then((res) => {
        console.log(res, "qqqqewq");
        this.Filterdata = res.data;
        this.Filtersearchlist.forEach((el) => {
          if (
            (el.type == "select" || el.type == "selectlinkage") &&
            el.selectoptionname &&
            el.selectoptionname != "buyer_list"
          ) {
            // let obj = { [el.value]: "", [el.label]: "全部" };
            el.selectoption = res.data[el.selectoptionname];
          }
        });
      });
    },
    Refresh() {
      this.Filtersearchlist.forEach((el) => {
        if (
          (el.type == "select" || el.type == "selectlinkage") &&
          el.selectoptionname
        ) {
          // let obj = { [el.value]: "", [el.label]: "全部" };
          el.selectoption = this.Filterdata[el.selectoptionname];
        }
      });
      Object.assign(this.$data.from, this.$options.data().from);
      this.from1 = JSON.parse(JSON.stringify(this.from));
      this.hqlist();
    },

    search(e) {
      this.from.page = 1;
      this.currentPage = 1;
      this.from = e;
      this.hqlist();
    },
    hqlist() {
      this.loading = true;
      this.$api.fr.platformfreightdiscountlist(this.from).then((res) => {
        console.log(res, "获取数据");
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      //   console.log(`每页 ${val} 条`);
      this.from.pageSize = val;
      this.from1.pageSize = val;
      this.hqlist();
    },
    handleCurrentChange(val) {
      this.from.page = val;
      this.from1.page = val;
      this.currentPage = val;
      this.hqlist();
    },
  },
};
</script>
<style lang="scss">
.goodsfreightReduction {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;
  .contents {
    padding: 0 20px;
    padding-top: 20px;
    box-sizing: border-box;
  }
  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    // background-color: #000;
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
